export default {
  slug: "clion",
  code: "CL",
  label: "CLion",
  isIDE: true,
  krakenDir: "CLion",
  thumbnailColor: "#00D980",
  logoFamily: "ide",
  // The code highlight of the Demo Video banners (Figma "YouTube", "Code
  // highlight color" of the product section).
  codeHighlightColor: "#21D789",
};
